module.exports = __webpack_public_path__ + "static/media/ad.742f40c5.png";